const en: Record<string, string> = {
  loading: "Loading...",
  loadingDashboard: "Loading dashboard...",
  loadingDates: "Loading dates...",
  loadingSlots: "Loading slots...",
  redirecting: "Redirecting...",
  authenticating: "Authenticating...",
  saving: "Saving...",
  savingEllipsis: "Saving...",
  pleaseWait: "Please wait...",
  pleaseWaitSignIn: "Please wait while we complete your sign-in.",
  failed: "Failed",
  failedToLoadSchedule: "Failed to load schedule",
  failedToLoadSettings: "Failed to load settings",
  sessionExpired: "Session expired",
  apiError: "API error: {status}",
  rescheduleFailed: "Reschedule failed",
  authFailed: "Authentication failed",
  authFailedTitle: "Authentication Failed",
  missingAuthCode: "Missing authorization code or state.",
  invalidState: "Invalid state parameter. Please try logging in again.",
  loginInitFailed: "Failed to initialize login. Please try again.",
  popupBlocked: "Popup blocked. Please allow popups for this site and try again.",
  loginWindowClosed: "Login window was closed.",
  accessDenied: "Access denied. Your account does not have admin privileges. Please contact your administrator.",
  accountDeactivated: "This account has been deactivated. Please contact your administrator to restore it.",
  yourAccount: "Your account",
  failedOpenLogin: "Failed to open login window.",
  bookingRescheduled: "Booking rescheduled successfully",
  companySettingsSaved: "Company settings saved",
  bookingPoliciesSaved: "Booking policies saved",
  scheduleSaved: "Schedule saved",
  lineConfigSaved: "LINE configuration saved",
  staffCreated: "Staff member added",
  staffUpdated: "Staff member updated",
  staffActivated: "Staff member activated",
  staffDeactivated: "Staff member deactivated",
  notifySettingSaved: "Notification setting saved",
  orderSaved: "Order saved",
  serviceCreated: "Service added",
  serviceUpdated: "Service updated",
  serviceActivated: "Service activated",
  serviceDeactivated: "Service deactivated",
  unavailabilityAdded: "Unavailability block added",
  unavailabilityRemoved: "Unavailability block removed",
  bookingCancelled: "Booking cancelled",
  bookingCompleted: "Booking marked complete",
  deactivateServiceConfirm: "Deactivate this service?",
  deactivateStaffConfirm: "Deactivate this staff member?",
  markCompleted: "Mark completed",
  completeBookingConfirm: "Mark this consultation as completed?",
  cancelBookingConfirm: "Cancel this booking?",
  deleteBookingConfirm: "Permanently delete this booking? This frees the slot and cannot be undone.",
  deleteCustomerConfirm: "Permanently delete this customer? Their bookings and conversations will also be deleted. This cannot be undone.",
  deleteConversationConfirm: "Permanently delete this conversation and all its messages? This cannot be undone.",
  deleteMailConfirm: "Permanently delete this mail thread? This cannot be undone.",
  deleteRescheduleConfirm: "Delete this reschedule record? The booking's date/time is unchanged. This cannot be undone.",
  rescheduleDeleted: "Reschedule record deleted",
  bookingDeleted: "Booking deleted",
  customerDeleted: "Customer deleted",
  conversationDeleted: "Conversation deleted",
  mailDeleted: "Mail thread deleted",
  removeBlockConfirm: "Remove this unavailability block?",
  yes: "Yes",
  no: "No",
  dashboard: "Dashboard",
  services: "Services",
  // The staff edit modal's service checkboxes (StaffLinkSection in core-ui's
  // admin runtime). Gym registers the same section over plans instead, and
  // defines its own wording for these keys.
  staffLinks: "Assigned Services",
  staffLinksHint: "This staff member is only offered for bookings of the selected services.",
  staffLinksNone: "No services selected — this staff member cannot be booked.",
  staffLinksSaveFailed: "Staff saved, but the service assignment could not be saved.",
  staff: "Staff",
  bookings: "Bookings",
  calendar: "Calendar",
  reschedules: "Reschedules",
  logs: "Logs",
  users: "Users",
  settings: "Settings",
  logout: "Logout",
  viewSite: "View site",
  language: "Language",
  bookingAdmin: "Admin",
  adminDesc: "Admin dashboard for booking management",
  addService: "Add Service",
  addStaff: "Add Staff",
  saveCompanyInfo: "Save Company Info",
  companyLogo: "Company Logo",
  companyLogoHelp: "Shown to customers on their booking pages. PNG, JPEG or WebP, up to 5 MB.",
  uploadLogo: "Upload Logo",
  replaceLogo: "Replace Logo",
  removeLogo: "Remove Logo",
  logoSaved: "Logo updated",
  logoRemoved: "Logo removed",
  saveBookingPolicies: "Save Booking Policies",
  saveLineConfig: "Save LINE Config",
  saveSchedule: "Save Schedule",
  createRichMenu: "Create Rich Menu",
  configureLine: "Configure LINE",
  signIn: "Sign in with auth service",
  allStatuses: "All Statuses",
  loginTitle: "Admin",
  loginSubtitle: "Sign in to your dashboard",
  todayBookings: "Today's Bookings",
  totalBookings: "Total Bookings",
  upcoming: "Upcoming",
  bookingsCount: "{n} bookings",
  activeUsers: "Active Users",
  pending: "Pending",
  totalRevenue: "Total Revenue",
  noBookingsToday: "No bookings today",
  todayReschedules: "Today's Reschedules",
  noReschedulesToday: "No reschedules today",
  noBookingsFound: "No bookings found",
  noServicesYet: "No services yet",
  noStaffYet: "No staff yet",
  noUsersFound: "No users found",
  noReschedulesFound: "No reschedules found",
  noBlocks: "No blocks",
  noAvailableSlots: "No available slots for this date.",
  clickDateToView: "Click a date to view bookings",
  noBookingsOnDate: "No bookings on {date}",
  selectDate: "Select a date",
  bookingCalendar: "Booking Calendar",
  crossOff: "Cross off",
  restore: "Restore",
  crossOffTitle: "Block this time",
  crossOffUntil: "Until",
  crossOffReason: "Note (optional)",
  crossOffReasonPlaceholder: "e.g. property viewing",
  existingCustomer: "Existing customer",
  noteOnly: "Note only",
  noteOnlyHint: "Books the slot with a note and no customer. It appears in the bookings list as a confirmed booking.",
  noteRequired: "A note is required when there is no customer",
  crossOffHint: "Click a free slot to cross it off; click a crossed-off slot to restore it.",
  crossedOff: "Crossed off",
  restoreSlotConfirm: "Restore this slot? It becomes bookable again and the note on it is deleted.",
  pastDateCannotChange: "Past dates can't be changed.",
  staffNotWorking: "This staff member is not working on this day.",
  selectStaffToManage: "Select a staff member to manage slots.",
  noBookingsForStaff: "No bookings for this staff member on this day.",
  rescheduleBooking: "Reschedule Booking",
  rescheduleBookingTitle: "Reschedule",
  addServiceTitle: "Add Service",
  editServiceTitle: "Edit Service",
  serviceCode: "Service Code",
  serviceCodeHint: "Used in booking URLs. Lowercase, no spaces (e.g. posture, shoulder)",
  oneTimeOnly: "One-time only",
  oneTimeOnlyHint: "Each customer can book this service only once",
  addStaffTitle: "Add Staff",
  editStaffTitle: "Edit Staff",
  weeklySchedule: "Weekly Schedule",
  addBreak: "Add break",
  scheduleWeekSummary: "{days} working days · {hours} a week",
  dayOff: "Day off",
  workingHours: "Hours",
  breakLabel: "Break (not bookable)",
  removeBreak: "Remove break",
  scheduleEndAfterStart: "End time must be after start time",
  newBlock: "New block",
  addBlock: "Add block",
  setHours: "Set hours",
  blockSummary: "{count} upcoming",
  upcomingTab: "Upcoming",
  pastTab: "Past",
  noUpcomingBlocks: "No upcoming blocks",
  noUpcomingBlocksHint: "Use the form above to block out a whole day or a few hours.",
  removeBlockConfirmDetail: "Remove the block on {when}?",
  scheduleBreakInside: "The break must start and end inside the working hours",
  bookable: "Bookable",
  copyToWorkingDays: "Copy these hours to all working days",
  breakTime: "Break (weekly schedule)",
  unavailabilityBlocks: "Unavailability Blocks",
  pastBlocks: "Past blocks",
  noPastBlocks: "No past blocks",
  availableTimes: "Available Times",
  companyInformation: "Company Information",
  bookingPolicies: "Booking Policies",
  moreActions: "More actions",
  lineIntegration: "LINE Integration",
  richMenu: "Rich Menu",
  companyName: "Company Name",
  description: "Description",
  phone: "Phone",
  email: "Email",
  chat: "Chat",
  emailUser: "Email",
  copy: "Copy",
  copied: "Copied",
  notFound: "Customer not found",
  address: "Address",
  timezone: "Timezone",
  type: "Type:",
  durationMinutes: "Duration (minutes)",
  priceYen: "Price (¥)",
  bio: "Bio",
  profilePhoto: "Profile Photo",
  lineIdHint: "LINE user ID for booking notifications",
  staffLinkUser: "Link customer record",
  staffUnlink: "Unlink",
  staffLinkUserHint: "Search a customer to fill the LINE ID and email fields from their record.",
  lineNotify: "LINE Notify",
  emailHint: "Email address for booking notifications",
  emailNotify: "Email Notify",
  removePhoto: "Remove Photo",
  slotInterval: "Slot Interval (minutes)",
  bufferTime: "Buffer Time (minutes)",
  cancellationPolicy: "Cancellation Policy (hours before appointment)",
  reminder24h: "24h Reminder",
  reminder1h: "1h Reminder",
  showSlotStaffCount: "Show staff count on time slots",
  showSlotStaffCountHelp: "Shows how many staff are free on each time slot in the booking flow, e.g. '2 open'",
  showServiceDuration: "Show service duration",
  showServiceDurationHelp: "Shows each service's duration (e.g. 60 min) on the booking site and in the LINE menu. Turning it off shows the price alone; slot generation is unaffected",
  pointsSection: "Points",
  pointsStatusOn: "On ({rate}% back)",
  pointsStatusOff: "Off",
  pointsManagedInAuth: "Points are now one balance shared by every app (clinic, gym and the rest), and are set in the auth service's admin, under OAuth Clients.",
  openingSpecialSection: "Opening Special",
  openingSpecialEnabled: "Apply the opening special",
  openingSpecialHelp: "When on, every menu item sells at the price below, and the booking site shows a banner with the original prices struck through. Free items and items already cheaper than this price are unchanged. Bookings keep the price they were made at, so ending the special does not change past bookings or their points",
  openingSpecialPrice: "Special price (¥)",
  openingSpecialPriceInvalid: "Enter a whole number of ¥1 or more",
  openingSpecialSave: "Save Opening Special",
  openingSpecialSaved: "Opening special saved",
  thPoints: "Points",
  pointsHistory: "Points history",
  pointsBalance: "Balance",
  pointsEmpty: "No points yet.",
  selectableLengths: "Customer chooses the length",
  selectableLengthsHint: "When on, the customer picks from the lengths below instead of a single fixed duration",
  bookingDurationOptions: "Selectable lengths (min)",
  bookingDurationOptionsHelp: "Comma-separated lengths a customer can choose when booking this service (e.g. 30, 60, 90)",
  bookingDuration: "Duration",
  lineChannelId: "Messaging API Channel ID",
  lineChannelSecret: "Messaging API Channel Secret",
  lineChannelAccessToken: "Messaging API Channel Access Token (Long-lived)",
  lineLoginChannelId: "LINE Login Channel ID",
  liffAppId: "LIFF App ID",
  liffEndpointUrl: "LIFF Endpoint URL",
  liffEndpointUrlHint: "Paste this into the LINE Developers console under the LINE Login channel \u2192 LIFF \u2192 this app \u2192 Endpoint URL. It must be the customer app above \u2014 not the admin site you are reading this on, which has its own login screen and would leave customers staring at it.",
  slotIntervalHelp: "Time between each bookable slot (e.g. 30 = 9:00, 9:30, 10:00...)",
  bufferTimeHelp: "Gap between bookings for cleanup/prep (blocks next slot after buffer)",
  lineConfigDesc: "Configure your LINE Official Account channel to enable messaging, rich menus, and LIFF integration.",
  richMenuDesc: "Create a default rich menu for your LINE Official Account. Requires all LINE channel fields to be configured.",
  lineDiagnose: "Diagnose",
  lineDiagnosing: "Checking...",
  lineDiagnoseDesc: "Check which LINE Official Account this channel access token controls, and whether the webhook is set up correctly.",
  lineDiagnoseOk: "No problems found.",
  lineConnectedOa: "Connected LINE Official Account",
  lineChatMode: "Response mode",
  lineChatModeBot: "Bot",
  lineChatModeChat: "Chat (LINE auto-replies)",
  lineTokenChannel: "Token's channel",
  lineConfiguredChannel: "Configured Channel ID",
  lineTokenExpiry: "Token expires in",
  lineTokenExpiryDays: "{days} days",
  lineWebhookUrl: "Webhook URL",
  lineWebhookUrlHint: "Paste this into the LINE Developers console under Messaging API → Webhook URL, then turn on \"Use webhook\".",
  lineWebhookExpected: "Expected",
  lineWebhookUnset: "Not set",
  lineWebhookActive: "Webhook enabled",
  lineWebhookTest: "Webhook test",
  lineWebhookTestOk: "OK",
  channelConfigured: "Channel configured",
  channelNotConfigured: "Not configured",
  liffIdSet: "LIFF ID set",
  liffIdNotSet: "LIFF ID not set",
  searchNamePhone: "Search by name or phone...",
  placeholderStart: "Start",
  placeholderEnd: "End",
  placeholderLineChannelId: "e.g. 1234567890 (Messaging API channel)",
  placeholderLineLoginChannelId: "e.g. 1234567890 (LINE Login channel for LIFF auth)",
  placeholderSecretSet: "Currently set — leave blank to keep",
  placeholderSecretUnset: "Channel secret from LINE Developers Console",
  placeholderAccessTokenSet: "Currently set — leave blank to keep",
  placeholderAccessTokenUnset: "Long-lived channel access token",
  placeholderLiffId: "e.g. 1657890123-aBcDeFgH",
  thWhen: "When",
  thSource: "Source",
  thDate: "Date",
  thTime: "Time",
  thNote: "Note",
  thUser: "User",
  thService: "Service",
  thStaff: "Staff",
  thStatus: "Status",
  thActions: "Actions",
  thName: "Name",
  thReorder: "Order",
  dragToReorderHint: "Drag to reorder",
  reorderFailed: "Could not save the new order",
  thDuration: "Duration",
  thPrice: "Price",
  thCategory: "Category",
  thMethod: "Method",
  meetingMethodPHONE: "By phone",
  meetingMethodEMAIL: "By email",
  meetingMethodIN_PERSON: "In person",
  thJoined: "Joined",
  thRescheduledBy: "Rescheduled By",
  thOriginal: "Original",
  thNew: "New",
  thRescheduledAt: "Rescheduled At",
  active: "Active",
  inactive: "Inactive",
  cancelled: "Cancelled",
  noShow: "No Show",
  confirmed: "Confirmed",
  completed: "Completed",
  allDay: "All day",
  actorUser: "USER",
  prev: "Prev",
  next: "Next",
  back: "Back",
  tryAgain: "Try Again",
  add: "Add",
  edit: "Edit",
  cancel: "Cancel",
  close: "Close",
  remove: "Remove",
  search: "Search",
  create: "Create",
  update: "Update",
  activate: "Activate",
  deactivate: "Deactivate",
  reschedule: "Reschedule",
  pagerRange: "{shown} of {total}",
  bookingCount: "{count} booking(s)",
  userCount: "{count} user(s)",
  sun: "Sun",
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  min: "min",
  addBooking: "Add Booking",
  addBookingTitle: "New Booking",
  addUser: "Add User",
  addUserTitle: "New User",
  userCreated: "User created",
  userCreateFailed: "Failed to create user",
  userEmailRequired: "Email is required",
  userNameRequired: "Name is required",
  userPhoneInvalid: "Enter a phone number starting with 0 (10–11 digits, e.g. 09012345678)",
  phonePlaceholder: "e.g. 09012345678",
  userEmailInvalid: "Enter a valid email address",
  userEmailExists: "A user with this email already exists",
  userActivated: "User activated",
  userDeactivated: "User deactivated",
  userStatusUpdateFailed: "Failed to update user status",
  editUserTitle: "Edit User",
  userUpdated: "User updated",
  userUpdateFailed: "Failed to update user",
  resetPassword: "Reset Password",
  resetPasswordTitle: "Reset Password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",
  passwordMismatch: "Passwords do not match",
  passwordTooShort: "Password must be at least 8 characters",
  passwordTooLong: "Password must be 72 characters or fewer",
  passwordResetDone: "Password reset",
  passwordResetFailed: "Failed to reset password",
  userNoLoginAccount: "This customer has no login account",
  dashboardAccount: "Dashboard account",
  dashboardAccountLocked: "Dashboard accounts cannot be modified from the customers page",
  deactivateUserConfirm: "Deactivate this user? They will not be able to log in.",
  selectService: "Select a service",
  selectStaff: "Select staff",
  selectUser: "Select a user",
  searchUser: "Search user...",
  newUser: "New User",
  userName: "User Name",
  userPhone: "User Phone",
  bookingNotes: "Notes",
  viewFullNote: "View",
  bookingCreated: "Booking created",
  bookingCreateFailed: "Failed to create booking",
  selectTime: "Select a time",
  eventLogs: "Event Logs",
  allActions: "All Actions",
  allTypes: "All Types",
  allActors: "All Actors",
  clear: "Clear",
  eventCount: "{count} events",
  noLogsFound: "No logs found",
  thAction: "Action",
  thActor: "Actor",
  thTarget: "Target",
  thDetails: "Details",
  groupAuth: "Auth",
  groupBookings: "Bookings",
  groupServices: "Services",
  groupStaff: "Staff",
  groupUsers: "Users",
  groupSettings: "Settings",
  groupMessages: "Messages",
  groupMail: "Mail",
  targetAuth: "auth",
  targetBooking: "booking",
  targetService: "service",
  targetStaff: "staff",
  targetUser: "user",
  targetCompany: "company",
  targetConversation: "conversation",
  targetMailThread: "mail thread",
  targetReschedule: "reschedule",
  actorAdmin: "ADMIN",
  actorSystem: "SYSTEM",
  actionAuthLoginSuccess: "Login Success",
  actionAuthLoginFailed: "Login Failed",
  actionAuthAccessDenied: "Access Denied",
  actionBookingCreated: "Booking Created",
  actionBookingCancelled: "Booking Cancelled",
  actionBookingRescheduled: "Booking Rescheduled",
  actionBookingConfirmed: "Booking Confirmed",
  actionBookingCompleted: "Booking Completed",
  actionBookingNoShow: "No Show",
  actionBookingStatusUpdated: "Status Updated",
  actionServiceCreated: "Service Created",
  actionServiceUpdated: "Service Updated",
  actionServiceDeactivated: "Service Deactivated",
  actionServiceActivated: "Service Activated",
  actionStaffCreated: "Staff Created",
  actionStaffUpdated: "Staff Updated",
  actionStaffDeactivated: "Staff Deactivated",
  actionStaffActivated: "Staff Activated",
  actionStaffReordered: "Staff Reordered",
  actionScheduleUpdated: "Schedule Updated",
  actionUnavailabilityAdded: "Unavailability Added",
  actionUnavailabilityRemoved: "Unavailability Removed",
  actionUserCreated: "User Created",
  actionUserRegistered: "User Registered",
  actionUserUpdated: "User Updated",
  actionUserActivated: "User Activated",
  actionUserDeactivated: "User Deactivated",
  actionUserPasswordReset: "Password Reset",
  actionAuthSyncFailed: "Auth Sync Failed",
  actionSettingsUpdated: "Settings Updated",
  actionLineFollow: "LINE Follow",
  actionLineUnfollow: "LINE Unfollow",
  actionLineMessageReceived: "LINE Message Received",
  actionLineAutoReplySent: "LINE Auto-Reply",
  actionLineMessageSent: "LINE Reply Sent",
  actionLineQuotaExceeded: "LINE Quota Exceeded",
  actionConversationDeleted: "Conversation Deleted",
  actionMailMessageSent: "Mail Sent",
  actionMailThreadDeleted: "Mail Thread Deleted",
  actionBookingDeleted: "Booking Deleted",
  actionRescheduleDeleted: "Reschedule Deleted",
  actionUserDeleted: "User Deleted",
  logAuthLoginSuccess: "{name} ({email}) logged in via {source}",
  logAuthLoginFailed: "Login failed via {source}: {error}",
  logAuthAccessDenied: "Access denied for {email} — {reason}{role}",
  unverifiedSuffix: "(unverified)",
  logBookingCreated: "{actor} created a booking for {user} — {service} with {staff} at {time}",
  logBookingCancelled: "{actor} cancelled {user}'s booking — {service} with {staff}",
  logBookingRescheduled: "{actor} rescheduled {user}'s booking — {service} with {staff}: {oldDate} {oldTime} → {newDate} {newTime}",
  logBookingConfirmed: "{actor} confirmed {user}'s booking — {service} with {staff} at {time}",
  logBookingCompleted: "{actor} completed {user}'s booking — {service} with {staff} at {time}",
  logBookingNoShow: "{actor} marked {user} as no-show — {service} with {staff} at {time}",
  logBookingStatusUpdated: "{actor} updated {user}'s booking status: {oldStatus} → {newStatus}",
  logServiceCreated: "{actor} created service {name} ({duration}min, ¥{price})",
  logServiceUpdated: "{actor} updated service {name}",
  logServiceDeactivated: "{actor} deactivated service {name}",
  logServiceActivated: "{actor} activated service {name}",
  logStaffCreated: "{actor} added staff member {name}",
  logStaffUpdated: "{actor} updated staff member {name}",
  logStaffDeactivated: "{actor} deactivated staff member {name}",
  logStaffActivated: "{actor} activated staff member {name}",
  logStaffReordered: "{actor} reordered staff members",
  logScheduleUpdated: "{actor} updated schedule: {details}",
  logUnavailabilityAdded: "{actor} added unavailability: {details}",
  logUnavailabilityRemoved: "{actor} removed unavailability: {details}",
  logUserCreated: "{actor} created user {name} ({email})",
  logUserRegistered: "{name} registered",
  logUserUpdated: "{actor} updated user {name}: {fields}",
  logUserActivated: "{actor} activated user {name}",
  logUserDeactivated: "{actor} deactivated user {name}",
  logUserPasswordReset: "{actor} reset the password for user {name}",
  logAuthSyncFailed: "Syncing {operation} to the auth service failed: {error}",
  logSettingsUpdated: "{actor} updated settings: {fields}",
  logLineFollow: "{actor} added us on LINE",
  logLineUnfollow: "{actor} unfollowed us on LINE",
  logLineMessageReceived: "{actor} sent a LINE message",
  logLineAutoReplySent: "{actor} sent an auto-reply",
  logLineMessageSent: "{actor} replied via LINE",
  logLineQuotaExceeded: "{actor}: LINE quota exceeded — reminder not sent",
  logConversationDeleted: "{actor} deleted a conversation",
  logMailMessageSent: "{actor} sent a mail message",
  logMailThreadDeleted: "{actor} deleted a mail thread",
  logBookingDeleted: "{actor} deleted a booking — {user} · {service} · {staff}",
  logRescheduleDeleted: "{actor} deleted a reschedule request — {user} · {service} · {staff}",
  logUserDeleted: "{actor} deleted customer {name}",
  logMetaAuth: "Auth",
  logMetaBooking: "Booking #{id}",
  logMetaService: "Service #{id}",
  logMetaStaff: "Staff #{id}",
  logMetaUser: "User #{id}",
  logMetaCompany: "Company",
  logMetaConversation: "Conversation #{id}",
  logMetaMailThread: "Mail thread #{id}",
  logMetaReschedule: "Reschedule #{id}",

  messages: "LINE Messages",
  messagesTitle: "LINE Messages",
  messagesEmpty: "No messages yet — share your LINE link with customers!",
  inbox: "Inbox",
  unread: "unread",
  replyPlaceholder: "Type a reply...",
  send: "Send",
  sending: "Sending...",
  noConversationSelected: "Select a conversation",
  unknownCustomer: "Unknown customer",
  customerInfo: "Customer Info",
  recentBookings: "Recent Bookings",
  statusOpen: "Open",
  statusPending: "Pending",
  statusClosed: "Closed",
  customerUnreachable: "This customer cannot receive LINE messages (blocked or unfriended)",
  lineQuotaExceeded: "LINE message quota reached. Please retry shortly.",
  lineQuotaRemaining: "LINE messages left: {remaining} / {total}",
  lineQuotaUnlimited: "LINE quota: Unlimited",
  linePlanLimited: "Limited",
  linePlanUnlimited: "Unlimited",
  lineQuotaInline: "{plan} · {used}/{total} ({percent}%)",
  lineQuotaInlineUnlimited: "{plan} · {used} this month",
  lineNotConfigured: "LINE not configured",
  lineQuotaTitle: "LINE message quota",
  messageSent: "Sent",
  messageFailed: "Failed to send. Please try again",
  searchPlaceholder: "Search by name or message...",
  filterAll: "All",
  filterOpen: "Open",
  filterPending: "Pending",
  filterClosed: "Closed",
  filterUnassigned: "Unassigned",
  filterAssignedMe: "Assigned to me",
  noBookings: "No bookings",
  openInMessages: "Open in Messages",
  viewFullDetails: "View full details",
  service: "Service",
  colDate: "Date",
  colTime: "Time",
  bookingHistory: "Booking History",
  noMessagesYet: "No conversation yet",
  activityLog: "Activity Log",
  noActivity: "No activity",
  assignTo: "Assign to",
  retry: "Retry",
  stickerAlt: "Sticker",
  memberSince: "Joined",
  lineId: "LINE ID",
  notProvided: "—",
  mail: "Email",
  mailTitle: "Email",
  mailCompose: "Compose",
  mailComposeTitle: "New email",
  mailFrom: "From",
  mailTo: "To",
  mailSubject: "Subject",
  mailBody: "Message",
  mailComposeSent: "Email sent",
  goToMailPage: "Go to email page",
  mailFilter_all: "All",
  mailFilter_open: "Open",
  mailFilter_pending: "Pending",
  mailFilter_closed: "Closed",
  mailSearchPlaceholder: "Search email…",
  mailNoThreads: "No emails",
  mailNoSubject: "(no subject)",
  mailNoThreadSelected: "Select an email to read",
  mailLinkedCustomer: "Customer",
  mailStatus_open: "Open",
  mailStatus_pending: "Pending",
  mailStatus_closed: "Closed",
  mailStatusLabel: "Status",
  mailStaff: "Staff",
  mailUnknownCustomer: "Unknown customer",
  mailNoLinkedCustomer: "No linked customer",
  mailLoadFailed: "Failed to load email",
  mailSent: "Reply sent",
  mailSendFailed: "Failed to send reply",
  dateRequired: "Pick a date first",
  assignFailed: "Failed to change the assignee",
  statusUpdateFailed: "Failed to update the status",
  mailStatusUpdateFailed: "Failed to update the thread status",
  mailAllInboxes: "All",
  mailNoMailboxes: "No mailboxes configured. Add one in Settings → Email.",
  save: "Save",
  delete: "Delete",
  mailSettings: "Email",
  notifyFromTitle: "Send notifications from",
  notifyFromDesc: "Booking notification emails are sent from this address, and customer replies return to its inbox.",
  notifyFromDefault: "Default (service default sender)",
  notifyFromSaved: "Notification sender saved",
  mailboxesTitle: "Mailboxes",
  mailboxesDesc: "Inboxes polled over IMAP and shown in the Email inbox. Add one or more.",
  mailboxesEmpty: "No mailboxes yet.",
  mailboxAdd: "Add mailbox",
  mailboxEdit: "Edit mailbox",
  mailboxSaved: "Mailbox saved",
  mailboxDeleteConfirm: "Delete mailbox {email}? Its stored threads will be removed.",
  mailboxLabel: "Label",
  mailboxEmail: "Email address",
  mailboxFromName: "Sender name",
  mailboxImapHost: "IMAP host",
  mailboxImapPort: "IMAP port",
  mailboxEncryption: "Encryption",
  mailboxEncNone: "None",
  mailboxImapUser: "IMAP username",
  mailboxImapPassword: "IMAP password",
  mailboxPasswordKeep: "Leave blank to keep current",
  mailboxActive: "Active (poll this inbox)",
  mailboxInactive: "inactive",
  mailboxError: "poll error",

  // b2
  mailboxDeleted: "Mailbox deleted",

  // b3
  loadFailed: "Couldn't load this.",
  reconnecting: "Reconnecting...",
  mainNavigation: "Main",
  menu: "Menu",
  skipToContent: "Skip to main content",

  // b4
  today: "Today",
  jumpToMonth: "Jump to month",
  // Blog — admin/staff authoring.
  blog: "Blog",
  newPost: "New post",
  editPost: "Edit post",
  postTitle: "Title",
  postBody: "Body",
  postStatus: "Status",
  postDate: "Date",
  postTags: "Tags",
  postTagsHint: "Type a #hashtag, press space to add — shown on the post",
  categoryPlaceholder: "e.g. News",
  blogFilterCategories: "Categories",
  blogFilterTags: "Tags",
  blogFilterAll: "All",
  manageCategories: "Manage categories",
  editCategory: "Edit category",
  addCategory: "Add",
  movePostsTo: "Move its posts to",
  uncategorised: "Uncategorised",
  deleteCategoryConfirm: "Delete the category \"{name}\"? Its {count} post(s) will be affected.",
  viewPost: "View",
  draft: "Draft",
  published: "Published",
  postSaved: "Post saved",
  deletePost: "Delete",
  deletePostConfirm: "Delete this post permanently? This cannot be undone.",
  postDeleted: "Post deleted",
  uploadImageFailed: "Image upload failed",
  noPostsYet: "No posts yet",
  noPostsFound: "No posts match your search.",
  searchBlogPosts: "Search title, author, category or tag...",
  blogPostCount: "{count} post(s)",
  thAuthor: "Author",
  thPublishedAt: "Published",
  thUpdatedAt: "Updated",
  bold: "Bold",
  italic: "Italic",
  bulletList: "Bullet list",
  orderedList: "Numbered list",
  setLink: "Link",
  linkUrl: "Link URL",
  insertImage: "Insert image",
  undo: "Undo",
  redo: "Redo",
  // UI/UX pass, 2026-10-08
  roleSuperAdmin: "Super admin",
  roleAdmin: "Admin",
  roleStaff: "Staff",
  lineOnly: "LINE only",
  showLoginEvents: "Show logins",
  unreadLine: "Unread LINE",
  unreadMail: "Unread email",
  upcomingWeek: "Next 7 days",
  noUpcomingWeek: "No bookings in the next 7 days",
  chooseImage: "Choose image",
};
export default en;
